<!-- <div class="main-panel"> -->
<h1>Actualizar Centros</h1>
<div class="descripcion-paso">
  <p>Puedes actualizar los datos de centros arrastrando o seleccionando el documento Excel de centros.
  </p>
  <app-upload-file [accept]="'text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'" [textoFondo]="'Arrastra aquí el documento Excel de centros o haz click para seleccionarlo'" (fileListEmitter)="uploadFiles($event)"></app-upload-file>
</div>
<!-- </div> -->
